
import { singularityStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class EditBackgroundImageButton extends Vue {
  @Prop()
  elementId!: TreeNode["id"];

  editBackgroundImage() {
    singularityStore.setBackgroundImageEditorPanelState({
      sectionId: this.elementId,
    });
    singularityStore.setSingularityLeftPanel("background_image_editor");
  }
}
